/* ME → SKILLS — what she can do, picked from a list (her call, 2026-09-25:
 * "maybe we should just have a selector for now … and only that for now").
 *
 * A SELECTOR, not free text, for now: ten kinds of visibility she named. The
 * spec (docs/voice-layers-spec.md, "Me") has Skills becoming facts Brill uses
 * instead of inventing; that read is NOT built — her call, "only that" — so
 * today this is hers to keep and nothing drafts from it yet.
 *
 * Stored as the ids, in list order, in `settings.skills` (supabase/0033).
 * An id this list no longer has is dropped on read rather than shown as a
 * chip nobody can recognise.
 */
export const SKILL_CHOICES = [
  { id: "speaking", label: "Speaking" },
  { id: "writing", label: "Writing" },
  { id: "in_person", label: "In person" },
  { id: "conferences", label: "Conferences" },
  { id: "creative", label: "Creative" },
  { id: "technical", label: "Technical" },
  { id: "coding", label: "Coding" },
  { id: "tools_systems", label: "Creating tools and systems" },
  { id: "operations", label: "Operations" },
  { id: "coaching", label: "Coaching" },
];

const KNOWN = new Set(SKILL_CHOICES.map((s) => s.id));

export function readSkills(stored) {
  const list = Array.isArray(stored) ? stored : [];
  return SKILL_CHOICES.map((s) => s.id).filter((id) => list.includes(id) && KNOWN.has(id));
}

export function toggleSkill(skills, id) {
  if (!KNOWN.has(id)) return readSkills(skills);
  const on = readSkills(skills);
  return readSkills(on.includes(id) ? on.filter((x) => x !== id) : [...on, id]);
}
